import { render } from "./ApiKeyMgmt.vue?vue&type=template&id=28121624&scoped=true"
import script from "./ApiKeyMgmt.vue?vue&type=script&lang=js"
export * from "./ApiKeyMgmt.vue?vue&type=script&lang=js"

import "./ApiKeyMgmt.vue?vue&type=style&index=0&id=28121624&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28121624"]])

export default __exports__